import { render, staticRenderFns } from "./detail-apport.vue?vue&type=template&id=42ac9a46&scoped=true"
import script from "./detail-apport.vue?vue&type=script&lang=js"
export * from "./detail-apport.vue?vue&type=script&lang=js"
import style0 from "./detail-apport.vue?vue&type=style&index=0&id=42ac9a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ac9a46",
  null
  
)

export default component.exports